import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonComponent } from '../../../../../../components/form/elements/button';
import AnimalType from '../../../../../../enums/animal-type';
import css from './event-list.module.css';
import ActionButton from '../../../../../../components/action-button/button';
import pregnancyImage from '../../../animals/components/create-buttons/pregnancy.svg';
import separationImage from '../../../animals/components/create-buttons/separation.svg';
import breedingImage from '../../../animals/components/create-buttons/breeding.svg';
import grazingImage from '../../../animals/components/create-buttons/grazing.svg';
import weighingImage from '../../../animals/components/create-buttons/weighing.svg';
import starter_feedImage from '../../../animals/components/create-buttons/starter_feed.svg';
import otherImage from '../../../animals/components/create-buttons/other.svg';
import { route } from '../../../../../../services/utils';
import {
  LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_CREATE,
  LIVESTOCK_ANIMALS_GRAZING_CREATE,
  LIVESTOCK_ANIMALS_OTHER_CREATE,
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_CREATE,
  LIVESTOCK_ANIMALS_SEPARATION_CREATE,
  LIVESTOCK_ANIMALS_BREEDING_CREATE,
  LIVESTOCK_ANIMALS_WEIGHING_CREATE,
} from '../../../../../../router/routes';
import ActionContainer from '../../../../../../components/action-button/container';
import ShowIfAllowed from '../../../../../../components/common/show-if-allowed';
import './create-buttons.css';
import { useHistory } from 'react-router-dom';

interface Props {
  farmId: string;
  useCalendarView: boolean;
  setUseCalendarView: Dispatch<SetStateAction<boolean>>;
}

export default function EventListButtons({
  farmId,
  useCalendarView,
  setUseCalendarView,
}: Props) {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <>
      <div className={css['event-bar']}>
        <ActionContainer>
          <ShowIfAllowed ability={{ title: 'create animal_event' }}>
            <ActionButton
              name={AnimalType.pregnancy}
              icon={<img src={pregnancyImage} alt="" />}
              route={route(LIVESTOCK_ANIMALS_PREGNANCY_CHECK_CREATE, {
                animalType: AnimalType.pregnancy,
                farmId,
              })}
              text={t(
                'pages.livestock.animals_and_events.animals.types.pregnancy'
              )}
            />
            <ActionButton
              name={AnimalType.separation}
              icon={<img src={separationImage} alt="" />}
              route={route(LIVESTOCK_ANIMALS_SEPARATION_CREATE, {
                animalType: AnimalType.separation,
                farmId,
              })}
              text={t(
                'pages.livestock.animals_and_events.animals.types.separation'
              )}
            />
            <ActionButton
              name={AnimalType.grazing}
              icon={<img src={grazingImage} alt="" />}
              route={route(LIVESTOCK_ANIMALS_GRAZING_CREATE, {
                animalType: AnimalType.grazing,
                farmId,
              })}
              text={t(
                'pages.livestock.animals_and_events.animals.types.grazing'
              )}
            />
            <ActionButton
              name={AnimalType.weighing}
              icon={<img src={weighingImage} alt="" />}
              route={route(LIVESTOCK_ANIMALS_WEIGHING_CREATE, {
                animalType: AnimalType.weighing,
                farmId,
              })}
              text={t(
                'pages.livestock.animals_and_events.animals.types.weighing'
              )}
            />
            <ActionButton
              name={AnimalType.starter_feed}
              icon={<img src={starter_feedImage} alt="" />}
              route={route(LIVESTOCK_ANIMAL_EVENTS_STARTER_FEED_CREATE, {
                farmId,
              })}
              text={t(
                'pages.livestock.animals_and_events.animals.types.starter_feed'
              )}
            />
            <ActionButton
              name={AnimalType.breeding}
              icon={<img src={breedingImage} alt="" />}
              route={route(LIVESTOCK_ANIMALS_BREEDING_CREATE, {
                animalType: AnimalType.breeding,
                farmId,
              })}
              text={t(
                'pages.livestock.animals_and_events.animals.types.breeding'
              )}
            />
            <ActionButton
              name={AnimalType.other}
              icon={<img src={otherImage} alt="" />}
              route={route(LIVESTOCK_ANIMALS_OTHER_CREATE, {
                animalType: AnimalType.other,
                farmId,
              })}
              text={t('pages.livestock.animals_and_events.animals.types.other')}
            />
          </ShowIfAllowed>
        </ActionContainer>
        <div className={css['change-view']}>
          <ButtonComponent
            name="change-view"
            label={t(
              'pages.livestock.animals_and_events.events.list_of_events'
            )}
            click={() => {
              const search = new URLSearchParams();
              history.push({ ...history.location, search: search.toString() });
              setUseCalendarView(!useCalendarView);
            }}
          />
        </div>
      </div>
    </>
  );
}
